exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".knowledge-view-dialog .is-fullscreen .el-dialog__body{height:calc(100% - 80px) !important}.knowledge-view-dialog .is-fullscreen .el-dialog__body>div{height:100%}.knowledge-view-dialog .is-fullscreen .knowledge-container{height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.knowledge-view-dialog .is-fullscreen .knowledge-container .content{-webkit-box-flex:1;-ms-flex:1;flex:1;max-height:none}", ""]);

// exports
